<template>
 <div class="mt-20 table-with-action"
  :class="{'table-with-add': showAddDeliveryNumbers}">
    <div class="add-block" v-if="showAddDeliveryNumbers" @click="addNewRow()">
      {{$t('INDENT_ADD_DELIVERY_NUMBERS')}}
    </div>
    <Table
      :data="deliveryDetailsForDestination"
      :stripe="true"
      max-height="400px"
      class="table-striped bordered"
      aria-describedby="deliveryNumbersData"
      >
      <TableColumn
        label="Pickup Gate"
        width="300">
         <template slot-scope="scope">
          <Select
            :value="scope.row.source_id"
            @input="updateValue($event,'source_id',scope.row.delDetailIndex)"
            placeholder="Select"
            size="mini"
            class="select-default no-bg ml-m10">
            <Option
              v-for="item in gatesList"
              :key="item.id"
              :label="`${item.name} - ${item.reference_id}`"
              :disabled="isAlreadySelectedGate(item.id)"
              :value="item.id">
            </Option>
          </Select>
        </template>
      </TableColumn>
      <TableColumn
        v-if="showDropGate"
        label="Drop Gate"
        width="300">
         <template slot-scope="scope">
          <Select
            :disabled="!scope.row.source_id"
            :value="scope.row.ship_to_id"
            @input="updateValue($event,'ship_to_id',scope.row.delDetailIndex)"
            placeholder="Select"
            size="mini"
            class="select-default no-bg ml-m10">
            <Option
              v-for="item in dropGatesList"
              :key="item.id"
              :label="`${item.name} - ${item.reference_id}`"
              :disabled = "isAlreadySelectedDropGate(item.id,scope.row.source_id)"
              :value="item.id">
            </Option>
          </Select>
        </template>
      </TableColumn>
      <TableColumn
        label="Delivery Numbers">
         <template slot-scope="scope">
            <Input
              placeholder="Enter"
              :value="scope.row.delivery_numbers"
              @input="updateValue($event,'delivery_numbers',scope.row.delDetailIndex)"
              size="mini"
              class="form-control input-blank p-0">
            </Input>
        </template>
      </TableColumn>
      <TableColumn
         width="120">
        <template slot-scope="scope">
          <i class="action-row">
            <svgicon name="icon-delete-md" width="14" height="14" @click="deleteRow(scope.row.delDetailIndex)" />
          </i>
        </template>
      </TableColumn>
    </Table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { sourceAndDestinationType } from 'pando-constants';

export default {
  props: ['gatesList', 'destination', 'dropGatesList', 'order', 'soldToIdMap'],
  components: {
  },
  data() {
    return {
      sourceAndDestinationType,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      deliveryDetails: 'order/deliveryNumberDetails',
    }),
    deliveryDetailsForDestination() {
      return this.deliveryDetails.map((val, index) => ({ ...val, ...{ delDetailIndex: index } })).filter(val => this.destination.location_id === val.location_id);
    },
    showAddDeliveryNumbers() {
      return this.deliveryDetailsForDestination.length < this.order.destinations.filter(dest => dest.location_id === this.destination.location_id).length;
    },
    showDropGate() {
      return [this.sourceAndDestinationType.DEPOT, this.sourceAndDestinationType.VENDOR_DEPOT].includes(this.destination.type);
    },


  },
  methods: {
    isAlreadySelectedGate(gateId) {
      const count = this.deliveryDetailsForDestination.filter(val => val.source_id === gateId).length;
      return count >= this.dropGatesList.length;
    },
    isAlreadySelectedDropGate(dropGateId, pickUpGateId) {
      const key = `${pickUpGateId}_${dropGateId}`;
      if (!this.soldToIdMap[key]) {
        return true;
      }
      return this.deliveryDetailsForDestination.some(val => val.ship_to_id === dropGateId
      && val.source_id === pickUpGateId);
    },
    updateValue(value, key, index) {
      const deliveryDetails = this.deliveryDetails;
      if (key === 'source_id') {
        deliveryDetails[index].source_id = value;
        deliveryDetails[index].source_type = this.gatesList.find(val => val.id === value).type;
      } else if (key === 'ship_to_id') {
        deliveryDetails[index].ship_to_id = value;
        deliveryDetails[index].destination_type = this.dropGatesList.find(val => val.id === value).type;
        const mapKey = `${deliveryDetails[index].source_id}_${deliveryDetails[index].ship_to_id}`;
        deliveryDetails[index].sold_to_id = this.soldToIdMap[mapKey];
      } else {
        deliveryDetails[index][key] = value;
      }
      this.$store.commit('order/SET_DELIVERY_NUMBER', deliveryDetails);
    },
    addNewRow() {
      const deliveryDetails = [...this.deliveryDetails];
      const obj = {
        location_id: this.destination.location_id,
        destination_type: this.destination.type, // 1 -depot, 2 -consignee, 3 -vendor depot
      };
      if (this.destination.type === this.sourceAndDestinationType.CONSIGNEE) {
        obj.ship_to_id = this.destination.location_id;
        obj.sold_to_id = this.destination.sold_to_id;
      }
      deliveryDetails.push(obj);
      this.$store.commit('order/SET_DELIVERY_NUMBER', deliveryDetails);
    },
    deleteRow(currentIndex) {
      const deliveryDetails = this.deliveryDetails.filter((val, index) => index !== currentIndex);
      this.$store.commit('order/SET_DELIVERY_NUMBER', deliveryDetails);
    },
  },
};
</script>
